import { Card } from 'components/@common/Card'
import { P } from 'components/common/P'
import styled from 'styled-components'

interface AddonStyleProps {
  active?: boolean
  error?: boolean
  disabled?: boolean
}

export const AddonSection = styled(Card)<AddonStyleProps>`
  display: flex;
  column-gap: 15px;
  width: 100%;
  max-width: 628px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    column-gap: 30px;
  }
`

export const Price = styled.p<AddonStyleProps>`
  font-family: ${(props) => props.theme.headerFontFamily};
  font-size: 44px;
  margin: 0;
  color: ${(props) => props.theme.primaryTextColour};
  line-height: 1em;
  margin-bottom: 0.3em;
  white-space: nowrap;
  ${({ active }) =>
    active &&
    `
    font-size: 22px;
  `}

  @media (max-width: 768px) {
    font-size: 26px;

    ${({ active }) =>
      active &&
      `
      font-size: 16px;
  `}
  }
`

export const AddonPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 130px;

  @media (max-width: 768px) {
    flex: 0 0 85px;
  }
`

export const AddonLogoContainer = styled.div`
  display: flex;
  align-items: center;
  width: 66px;
  flex: 0 0 66px;

  svg {
    width: 66px;
    height: 66px;

    #Path_538 {
      display: none;
    }
  }

  @media (max-width: 768px) {
    width: 40px;
    flex: 0 0 40px;

    svg {
      width: 40px;
      height: 40px;
    }
  }
`

export const AddonContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1 1 auto;
  justify-content: space-between;
`

export const AddonError = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 3px;
`

export const AddonContentHeader = styled.h3`
  font-family: ${(props) => props.theme.headerFontFamily};
  color: ${(props) => props.theme.headerFontColour};
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 1em;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`

export const AddonContentBody = styled(P)`
  font-family: ${(props) => props.theme.secondaryFontFamily};
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`
export const TextForGapPrice = styled.p`
  font-family: ${(props) => props.theme.fontFamily};
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 3px;

  @media (max-width: 768px) {
    font-size: 8px;
  }
`
export const LinkContainer = styled.a<AddonStyleProps>`
  font-size: 16px;
  color: ${(props) => props.theme.primaryTextColour};
  font-family: ${(props) => props.theme.headerFontFamily};
  text-decoration: underline;
  max-width: 130px;
  margin-top: 0.5em;

  :visited {
    color: ${(props) => props.theme.primaryTextColour};
  }

  @media (min-width: 768px) {
    font-size: 18px;
  }
`
